import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon, MapPinIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { images } from "../../i18n/translations";
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="relative w-full min-h-[92vh] flex items-center overflow-hidden" data-id="element-160" data-mp="huo1e2ebseqg">
      <img src={images.hero} alt="Planta trituradora de agregados en operación" className="absolute inset-0 h-full w-full object-cover object-[62%_center] sm:object-center" fetchpriority="high" data-id="element-161" data-mp="muadg8if3oxo" />
      {/* Mobile overlay is softened so the crushing plant remains visible. */}
      <div className="absolute inset-0 bg-navy-dark/60 sm:bg-navy-dark/75" aria-hidden="true" data-id="element-162" data-mp="10lysoknyqtiv" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy-dark/80 via-navy-dark/30 to-transparent sm:from-navy-dark/90 sm:via-navy-dark/50" aria-hidden="true" data-id="element-163" data-mp="15l1uzxck6ln5" />

      <div className="relative max-w-content mx-auto px-4 sm:px-6 w-full pt-28 pb-20" data-id="element-164" data-mp="9nj59x3sjo5c">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-3xl" data-id="element-165" data-mp="4opuicfw2b8v">
          <span className="inline-flex items-center gap-2 text-orange font-semibold text-xs sm:text-sm uppercase tracking-[0.2em]" data-id="element-166" data-mp="3rtxl61lme86d">
            <span className="h-px w-6 bg-orange" aria-hidden="true" data-id="element-167" data-mp="sczc1262kcu7" />
            {t.hero.eyebrow}
          </span>
          <h1 className="mt-5 font-heading font-bold uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02]" data-id="element-168" data-mp="nfzfpiz0uoga">
            {t.hero.headline}
          </h1>
          <p className="mt-6 text-slate-200 text-base sm:text-lg leading-relaxed max-w-2xl" data-id="element-169" data-mp="eluimhtaogsb">
            {t.hero.subtitle}
          </p>
          <div className="mt-5 inline-flex items-center gap-2 border-l-2 border-orange bg-black/25 px-3 py-2 text-sm font-semibold tracking-wide text-white" data-id="element-170" data-mp="1b63ad0u8fdv5">
            <MapPinIcon size={17} className="shrink-0 text-orange" aria-hidden="true" data-id="element-171" data-mp="30lnpyt1jafu6" />
            <span data-id="element-172" data-mp="35ljv4vlywdbb">{t.hero.location}</span>
          </div>
          <div className="mt-9 flex flex-col sm:flex-row gap-3" data-id="element-173" data-mp="35n36q8woi06r">
            <a href="#contacto" className="inline-flex items-center justify-center gap-2 rounded-sm bg-orange px-7 py-3.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-orange-dark" data-id="element-174" data-mp="2qvci4veqbmi0">
              {t.hero.ctaPrimary}
              <ArrowRightIcon size={18} data-id="element-175" data-mp="2mvafok166p1o" />
            </a>
            <a href="#contacto" className="inline-flex items-center justify-center rounded-sm border border-white/50 px-7 py-3.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-white hover:text-navy" data-id="element-176" data-mp="27x9r6b2mffhk">
              {t.hero.ctaSecondary}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}